export enum ExceptionCode {
    requestAttachmentRequiredException = 963,
    activityAttachmentRequiredException = 965,
    checkOrSetDeviceAvailableToMoveException = 967,
    engineerHasDifferentThanRequestServiceCenterException = 972,
    engineerDifferentServiceCenterChangeTidException = 1000,
}